// Lib
import React from 'react';
import { Typography } from '@mui/material';

// Styles
import { useStyles } from './InfoCardStyles';

const InfoCard = ({ title, children, dataTestId = '' }) => {
  const { classes } = useStyles();

  return (
    <div data-testid={dataTestId} className={classes.root}>
      <Typography mb={1} variant="h3" fontSize={{ xs: 14, md: 18 }}>
        {title}
      </Typography>
      {children}
    </div>
  );
};

export default InfoCard;
